export default __webpack_public_path__ + "static/abpc_logo_title_image-10bf2232832434dcf24a2f62180646e3.svg";